import { HttpRequest } from './HttpRequest'

export const GetIBNonIB = async (object: any[]) => {
    try {
        const data = JSON.stringify(object)
        const response = await HttpRequest().post(`/prospect/ibnon-ib`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            console.log('response', response)
            return response.data.responseData
        }
    } catch (error) {
        throw error
    }
}


export interface IGetIBNonIB {
    projectCode: string
    projectId: string
    unitCode: string
    bookingId: string
    nationality: string
    status: string
}